import FragmentArrayTransform from 'ember-data-model-fragments/transforms/fragment-array';
export default FragmentArrayTransform;
